module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_profile", [["table",{},[["tr",{},[["td",{},[["textNode",{"text":"Username"}]]],["td",{},[["span",{},[],[["login","__text",true]]]]]]],["tr",{},[["td",{},[["textNode",{"text":"Email"}]]],["td",{},[["span",{},[],[["email","__text",true]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-profile/templates.tpl
// module id = 549
// module chunks = 4